import Layout from "@/components/Layout"
import {Target, Users, Award} from 'lucide-react'

function About() {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            About Depreciation Hub
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Your trusted resource for professional depreciation and amortization
            calculations.
          </p>
        </div>

        {/* Mission Statement */}
        <div className="bg-blue-50 rounded-2xl p-8 sm:p-12 mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Our tools help you <strong>maximize tax deductions</strong>,{" "}
            <strong>simplify IRS compliance (Form 4562)</strong>, and{" "}
            <strong>master accounting fundamentals with zero cost</strong>. Whether
            you're a business owner, accountant, or student, Depreciation Hub provides
            accurate, professional-grade calculators that make complex depreciation
            calculations simple and accessible.
          </p>
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
              <Target className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Accurate & Reliable
            </h3>
            <p className="text-gray-600">
              All calculations follow IRS guidelines and accepted accounting principles.
            </p>
          </div>

          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
              <Users className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              User-Friendly
            </h3>
            <p className="text-gray-600">
              Intuitive interfaces designed for both professionals and beginners.
            </p>
          </div>

          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
              <Award className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              100% Free
            </h3>
            <p className="text-gray-600">
              No hidden fees, no subscriptions. Professional tools, completely free.
            </p>
          </div>
        </div>

        {/* Who We Serve */}
        <div className="bg-white rounded-xl border border-gray-200 p-8 sm:p-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Who We Serve</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Business Owners
              </h3>
              <p className="text-gray-600">
                Make informed decisions about asset purchases and maximize your tax
                deductions with accurate depreciation calculations.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Accountants & CPAs
              </h3>
              <p className="text-gray-600">
                Save time with reliable calculators that handle complex depreciation
                methods and IRS compliance requirements.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Students</h3>
              <p className="text-gray-600">
                Learn depreciation concepts with practical tools and clear explanations
                of formulas and methods.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About
